import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckedGreenRounded = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22 22",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 11,
			cy: 11,
			r: 11,
			fill: "#66B913"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "path-2-outside-1_337_6789",
			maskUnits: "userSpaceOnUse",
			x: 5.28564,
			y: 5.28571,
			width: 12,
			height: 11,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 5.28564,
				y: 5.28571,
				width: 12,
				height: 11
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16.5663 6.49281C16.1648 6.16893 15.5769 6.23181 15.253 6.63325L9.90468 13.2624L7.87998 11.2377C7.51526 10.873 6.92392 10.873 6.55919 11.2377C6.19446 11.6024 6.19446 12.1938 6.55919 12.5585L9.20078 15.2001C9.29493 15.2942 9.40418 15.3641 9.52073 15.4096C9.91549 15.655 10.4404 15.5732 10.7397 15.2022L16.7067 7.80611C17.0306 7.40467 16.9677 6.81668 16.5663 6.49281Z"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.5663 6.49281C16.1648 6.16893 15.5769 6.23181 15.253 6.63325L9.90468 13.2624L7.87998 11.2377C7.51526 10.873 6.92392 10.873 6.55919 11.2377C6.19446 11.6024 6.19446 12.1938 6.55919 12.5585L9.20078 15.2001C9.29493 15.2942 9.40418 15.3641 9.52073 15.4096C9.91549 15.655 10.4404 15.5732 10.7397 15.2022L16.7067 7.80611C17.0306 7.40467 16.9677 6.81668 16.5663 6.49281Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.253 6.63325L15.0563 6.47459V6.47459L15.253 6.63325ZM16.5663 6.49281L16.4076 6.68946V6.68946L16.5663 6.49281ZM9.90468 13.2624L9.72601 13.4411L9.92481 13.6399L10.1013 13.4211L9.90468 13.2624ZM7.87998 11.2377L7.70131 11.4164L7.87998 11.2377ZM6.55919 11.2377L6.73786 11.4164L6.55919 11.2377ZM6.55919 12.5585L6.38052 12.7372H6.38052L6.55919 12.5585ZM9.20078 15.2001L9.37945 15.0214H9.37945L9.20078 15.2001ZM9.52073 15.4096L9.65413 15.195L9.63437 15.1827L9.61269 15.1743L9.52073 15.4096ZM10.7397 15.2022L10.5431 15.0435V15.0435L10.7397 15.2022ZM16.7067 7.80611L16.5101 7.64745V7.64745L16.7067 7.80611ZM15.4496 6.79191C15.6859 6.49908 16.1148 6.45321 16.4076 6.68946L16.7249 6.29615C16.2149 5.88465 15.4678 5.96454 15.0563 6.47459L15.4496 6.79191ZM10.1013 13.4211L15.4496 6.79191L15.0563 6.47459L9.70803 13.1037L10.1013 13.4211ZM7.70131 11.4164L9.72601 13.4411L10.0834 13.0837L8.05866 11.059L7.70131 11.4164ZM6.73786 11.4164C7.00391 11.1503 7.43526 11.1503 7.70131 11.4164L8.05866 11.059C7.59525 10.5956 6.84392 10.5956 6.38052 11.059L6.73786 11.4164ZM6.73786 12.3798C6.47181 12.1138 6.47181 11.6824 6.73786 11.4164L6.38052 11.059C5.91711 11.5224 5.91712 12.2738 6.38052 12.7372L6.73786 12.3798ZM9.37945 15.0214L6.73786 12.3798L6.38052 12.7372L9.02211 15.3788L9.37945 15.0214ZM9.61269 15.1743C9.52803 15.1412 9.44846 15.0904 9.37945 15.0214L9.02211 15.3788C9.1414 15.4981 9.28033 15.587 9.42877 15.645L9.61269 15.1743ZM10.5431 15.0435C10.3248 15.314 9.94186 15.3739 9.65413 15.195L9.38734 15.6242C9.88912 15.9361 10.5559 15.8324 10.9364 15.3608L10.5431 15.0435ZM16.5101 7.64745L10.5431 15.0435L10.9364 15.3608L16.9034 7.96477L16.5101 7.64745ZM16.4076 6.68946C16.7005 6.92571 16.7463 7.35462 16.5101 7.64745L16.9034 7.96477C17.3149 7.45472 17.235 6.70765 16.7249 6.29615L16.4076 6.68946Z",
			fill: "white",
			mask: "url(#path-2-outside-1_337_6789)"
		})
	]
});
export default SvgCheckedGreenRounded;
